<div class="create-match-container">
    <h2>Crear partidos del grupo</h2>
    <div style="text-align: center; margin: 1rem;">
        <h3>{{category}} - {{groupName}}</h3>
    </div>

    <form [formGroup]="form" (ngSubmit)="submit()">

        <mat-form-field appearance="fill">
            <mat-label>Fecha</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="date" />
            <mat-datepicker-toggle matSuffix [for]="picker" />
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Hora</mat-label>
            <input matInput type="time" formControlName="time" />
        </mat-form-field>

        <div class="buttons">
            <button matButton="filled" type="submit" [disabled]="form.invalid">Crear partidos</button>
            <button matButton="outlined" type="button" (click)="exit()">Salir</button>
        </div>
    </form>
</div>